import React from "react";

function Cancellation() {
  return (
    <div>
      <h2
        style={{
          marginBottom: 20,
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 20,
        }}
      >
        Shipping Policy
      </h2>
      <ul style={{ marginLeft: 20, marginRight: 20 }}>
        <li>
        We offer the following shipping methods:
        </li>
        <ol>
        <li>
        Standard Shipping
        </li>
        <li>
        Expedited Shipping
        </li>
        </ol>
        <li>
        Standard Shipping: Rs 45.00
        </li>
        <li>
        Expedited Shipping: Rs 60.00
        </li>
        <li>
        Orders over Rs 4000.00 qualify for free standard shipping.
        </li>
        <li>
        We currently ship to the following zones:
        </li>
        <ol>
        <li>
          Jind, Haryana
        </li>
        </ol>
        <li>
        Please allow 1-2 business days for order processing. Orders placed on weekends or holidays will be processed on the next business day.
        </li>
        <li>
        Standard Shipping: 2 business days
        </li>
        <li>
        Expedited Shipping: 1 business day
        </li>
        <li>Note: Delivery times may vary based on the shipping destination.
        </li>
        <li>
        We don't offer international shipping.
        </li>
        <li>
        Customers are responsible for any customs duties or taxes imposed by their country.
        </li>
        <li>
        Order tracking information will be provided via email once your order has been shipped.
        </li>
        <li>
        We work with trusted shipping carriers only.
        </li>
        <li>
        Certain products may have shipping restrictions due to legal or safety reasons. Please refer to the product descriptions for more information.
        </li>
        <li>
        Certain products may have shipping restrictions due to legal or safety reasons. Please refer to the product descriptions for more information.
        </li>
        <li>
        We will keep you informed about your order status and provide updates on any delays via email. Make sure to provide accurate contact information during checkout.
        </li>
        <li>
        Thank you for choosing Parchun King! If you have any further questions or concerns, feel free to reach out to us.
        </li>
      </ul>
      <div
        style={{
          textAlign: "center",
          paddingTop: 7,
          paddingBottom: 7,
          backgroundColor: "lightgray",
        }}
      >
        Made with ❤️ by Sheetal Trading Company
      </div>
    </div>
  );
}

export default Cancellation;
